import { Route } from 'app/enums';
import { useMemo } from 'react';
import { NavigationMenuItem } from 'app/interfaces/sidebar';
import config from 'config/config';
import { useNavigate } from 'react-router-dom';
import { SUPPORT_EMAIL } from 'shared/constants';
import { AlternateEmail, OpenInNew as OpenInNewIcon } from '@mui/icons-material';

interface MobileSideMenuHook {
  policesMenu: NavigationMenuItem[];
}

export function useMobileSideMenu(): MobileSideMenuHook {
  const navigate = useNavigate();

  const policesMenu: NavigationMenuItem[] = useMemo(
    () => [
      {
        label: 'Players Online',
        onClick: () => navigate(Route.PlayersOnline),
        hideOnClick: true,
        isAllowedWithoutAuthorization: false,
      },
      {
        label: 'Terms of Service',
        onClick: () => window.open(config?.termsOfUseUrl, '_blank'),
        icon: OpenInNewIcon,
        hideOnClick: false,
        isAllowedWithoutAuthorization: true,
      },
      {
        label: 'Tournament Rules',
        onClick: () => window.open('https://docs.okletsplay.com/legal/tournament-rules', '_blank'),
        icon: OpenInNewIcon,
        hideOnClick: false,
        isAllowedWithoutAuthorization: true,
      },
      {
        label: SUPPORT_EMAIL,
        onClick: () => window.open(`mailto:${SUPPORT_EMAIL}`, '_blank'),
        icon: AlternateEmail,
        hideOnClick: false,
        isAllowedWithoutAuthorization: true,
      },
    ],
    [navigate]
  );

  return { policesMenu };
}
